/**
 * Generated bundle index. Do not edit.
 */

export {MdSliderModule,MD_SLIDER_VALUE_ACCESSOR,MdSliderChange,MdSliderBase,_MdSliderMixinBase,MdSlider,MAT_SLIDER_VALUE_ACCESSOR,MatSlider,MatSliderBase,MatSliderChange,MatSliderModule} from './public_api';
